import { combineReducers, applyMiddleware, compose } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import { thunk } from 'redux-thunk';
import { httpReducer } from './reducer/http';
import { layerConfigReducer } from './reducer/layerConfig';
import { layerDataReducer } from './reducer/layerData';
import { userReducer } from './reducer/user';
import {activityReducer} from './reducer/activity';

const rootReducer = combineReducers({
    layerData: layerDataReducer,
    layerConfig: layerConfigReducer,
    http: httpReducer,
    user: userReducer,
    activity: activityReducer
});

const reduxExtension = (window as any).__REDUX_DEVTOOLS_EXTENSION__ && (window as any).__REDUX_DEVTOOLS_EXTENSION__();

const middlewares = reduxExtension ? compose(applyMiddleware(thunk), reduxExtension) : applyMiddleware(thunk);

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({serializableCheck: false})
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
